import BaseService from '@core/class/BaseService';
import axios from 'axios';

class SellerServices extends BaseService {
  public getContactWarehouse = () => {
    return this.get('api/v1/seller/warehouses/dashboard');
  };

  public getTotalProduct = () => {
    return this.get('api/v1/seller/products/total-product');
  };

  public getDashboardStock = () => {
    return this.get('api/v1/seller/products/dashboard-stock');
  };

  public getDashboardOrder = () => {
    return this.get('api/v1/seller/orders/dashboard');
  };

  public getCount = (status: number) => {
    let statusUse = status == 3 ? 'In_Delivery' : 'Request';
    return this.get(`api/v1/seller/orders/count?status=${statusUse}`);
  };

  public isGetOrder = () => {
    return axios.all([this.getCount(3), this.getCount(2)]).then(
      axios.spread(function (res1, res2) {
        return { data: res2.data > res1.data ? true : false };
      })
    );
  };

  public getDashboardOrderCount = (status: string) => {
    return this.get(`api/v1/seller/orders/count?status=${status}`);
  };

  public getDashboardTotalShippingCount = () => {
    return this.get(`api/v1/seller/orders/count`);
  };

  public getDashboardReturnCount = () => {
    return this.get(`api/v1/seller/returns/count`);
  };

  public getDashboardSummary = async () => {
    
    return await axios.all([
      this.getTotalProduct(),
      this.getDashboardTotalShippingCount(),
      this.getDashboardReturnCount(),
      this.getDashboardOrderCount("Inprogress"), 
      this.getDashboardOrderCount("Delivered"),
    ]).then(
      axios.spread(function (res1, res2, res3, res4, res5) {
        return { data: [
            res1.data, res2.data, res3.data, res4.data, res5.data
          ]
        };
      })
    );
  };

  public getNotifications = async (data: { page: number; limit: number }) => {
    const { page, limit } = data;
    return await this.get(`api/v1/seller/notifications?page=${page}&limit=${limit}`);
  };

  public readNotification = async (id: number) => {
    return await this.post(`api/v1/seller/notifications/${id}/mark-read`);
  };

  public isUnreadNotification = async () => {
    return await this.get(`api/v1/seller/notifications/count-unread`);
  };

  public getNotiEventSource = () => {
    return this.initEventSource('/api/v1/seller/notifications/listen');
  };

  public deleteNotification = async (id: number) => {
    return await this.delete(`api/v1/seller/notifications/${id}`);
  };
}

export default new SellerServices('/', true);
